import React from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { Typography } from '@mui/material';

import RoomRateExtraGuestSurcharges from '~/components/Vendors/Properties/RoomRateExtraGuestSurcharges';

import { roomRateAvailabilityQueryKeys } from '~/hooks/apis/reservation/roomRateAvailabilityQueryKeys';
import { useGetRoomRateExtraGuestSurcharges } from '~/hooks/apis/reservation/useGetRoomRateExtraGuestSurcharges';

import ReservationService from '~/services/ReservationService';

interface Props {
  propertyId: string;
  roomType: App.RoomType;
  roomRate: App.RoomRate;
  vendorCurrencyCode: string;
}

export default function ExtraGuestSurchargesTab({ propertyId, roomType, roomRate, vendorCurrencyCode }: Props) {
  const queryClient = useQueryClient();
  const { data: extraGuestSurcharges = [] } = useGetRoomRateExtraGuestSurcharges(propertyId, roomType.id, roomRate.id);

  function invalidate() {
    queryClient.invalidateQueries({
      queryKey: roomRateAvailabilityQueryKeys.extraGuestSurcharges(propertyId, roomType.id, roomRate.id),
    });
  }

  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Populated by applying the extra guest surcharge lines from this room's Salesforce deal options — edits here are
        independent of Salesforce afterward. Amounts are per extra guest, per night, in AUD.
      </Typography>

      <RoomRateExtraGuestSurcharges
        propertyId={propertyId}
        roomType={roomType}
        roomRate={roomRate}
        vendorCurrencyCode={vendorCurrencyCode}
        extraGuestSurcharges={extraGuestSurcharges}
        onUpdateRoomRateExtraGuestSurcharge={invalidate}
        deleteExtraGuestSurcharge={async (id: string) => {
          await ReservationService.deleteExtraGuestSurcharge(id, propertyId, roomType.id, roomRate.id);
          invalidate();
        }}
      />
    </>
  );
}
